import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_PresentationMainForm = _resolveComponent("PresentationMainForm")!

  return (_openBlock(), _createBlock(_component_PresentationMainForm, {
    countryId: _ctx.form.countryId,
    "onUpdate:countryId": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.countryId) = $event)),
    year: _ctx.form.year,
    "onUpdate:year": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.year) = $event)),
    countries: _ctx.getFilteredCountries,
    disabled: _ctx.disabled,
    loading: _ctx.isLoading,
    onSubmit: _ctx.onDownload
  }, {
    default: _withCtx(() => [
      _createVNode(_component_InputBlock, {
        title: "Формат файла",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectMultiComponent, {
            ref: "fileTypeSelect",
            selectId: "presentation-file-type",
            placeholder: "Укажите формат",
            labelOptions: "text",
            valueProp: "id",
            modelValue: _ctx.fileTypeModel,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileTypeModel) = $event)),
            options: _ctx.fileTypeOptions,
            disabled: _ctx.disabled || _ctx.isLoading,
            required: "",
            isDirtyValidation: ""
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["countryId", "year", "countries", "disabled", "loading", "onSubmit"]))
}